import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { DashboardDesktopView } from '../views/DashboardDesktopView';
import { DashboardMobileView } from '../views/DashboardMobileView';
import { DashboardTabletView } from '../views/DashboardTabletView';

export function DashboardPage() {
  const device = useDeviceClass();
  if (device === 'mobile') return <DashboardMobileView />;
  if (device === 'tablet') return <DashboardTabletView />;
  return <DashboardDesktopView />;
}
